import { css } from 'styled-components';

import { get } from '../constants';

export default css`
  position: relative;
  display: inline-block;
  padding: ${get('space.3')}px ${get('space.4')}px;
  font-family: ${get('fonts.sans')};
  font-size: ${get('fontSizes.2')}px;
  font-weight: ${get('fontWeights.normal')};
  line-height: ${get('lineHeights.normal')};
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border-radius: 12px;
  appearance: none;
  text-decoration: none;
  text-align: center;
  transition: all 0.5s;
  box-shadow: none;

  // default colors
  background-color: ${get('colors.primary')};
  color: ${get('colors.white')};

  // custom styles
  border: 0;

  &:hover {
    // needed to override link styles
    text-decoration: none;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    cursor: default;
    background-color: ${get('colors.greyscale.grey4')};
    border-color: ${get('colors.greyscale.grey4')};
  }
  &:disabled svg {
    opacity: 0.9;
  }
`;
